import { PlatformSettingsSection } from "@/components/admin/settings/PlatformSettingsSection";
import { AdminSettingsSectionShell } from "../AdminSettingsSectionShell";

export function PlatformSection() {
  return (
    <AdminSettingsSectionShell
      title="Platforma"
      description="Globalna pravila rezervacije, provizije, bank transfera i poslovnih računa."
    >
      <PlatformSettingsSection />
    </AdminSettingsSectionShell>
  );
}
